/* CTPC promo gifts — config lives in snippets/ctpc-promo-gifts.liquid */
(function () {
  const cfg = window.CTPC_PROMO;
  if (!cfg) return;

  const active = () => Date.now() < new Date(cfg.endsAt).getTime();
  const nativeFetch = window.fetch.bind(window);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let busy = false;

  const isGiftLine = (item) =>
    item.properties && item.properties[cfg.propertyName] === cfg.propertyValue;
  const getCart = () => nativeFetch(root + 'cart.js', { headers: json }).then((r) => r.json());

  // How many Nr. 3 Diamonds does this cart/add request add? (0 = none)
  function addedTriggerQty(body) {
    const id = String(cfg.triggerVariantId);
    let qty = 0;
    try {
      if (body instanceof FormData) {
        if (String(body.get('id')) === id) qty += parseInt(body.get('quantity') || 1, 10);
        for (const [k, v] of body.entries()) {
          const m = k.match(/^items\[(\d+)\]\[id\]$/);
          if (m && String(v) === id) qty += parseInt(body.get(`items[${m[1]}][quantity]`) || 1, 10);
        }
      } else if (typeof body === 'string') {
        if (body.trim().startsWith('{')) {
          const data = JSON.parse(body);
          (data.items || [data]).forEach((i) => {
            if (String(i.id) === id) qty += parseInt(i.quantity || 1, 10);
          });
        } else {
          const params = new URLSearchParams(body);
          if (params.get('id') === id) qty += parseInt(params.get('quantity') || 1, 10);
        }
      }
    } catch (e) {}
    return qty;
  }

  const racketQtyIn = (cart) =>
    cart.items.filter((i) => i.variant_id === cfg.triggerVariantId).reduce((n, i) => n + i.quantity, 0);

  // Set each free gift to (rackets x gift quantity): add, top up, reduce or remove as needed.
  async function syncGifts(cart, racketQty) {
    const updates = {};
    const toAdd = [];
    for (const gift of cfg.gifts) {
      const lines = cart.items.filter((i) => i.variant_id === gift.variantId && isGiftLine(i));
      const want = active() ? racketQty * gift.quantity : 0;
      if (!lines.length && want) toAdd.push({ ...gift, quantity: want });
      lines.forEach((line, n) => {
        const q = n === 0 ? want : 0;
        if (line.quantity !== q) updates[line.key] = q;
      });
    }
    if (Object.keys(updates).length) {
      await nativeFetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates }) });
    }
    if (toAdd.length) {
      await nativeFetch(root + 'cart/add.js', {
        method: 'POST',
        headers: json,
        body: JSON.stringify({
          items: toAdd.map((g) => ({
            id: g.variantId,
            quantity: g.quantity,
            properties: { [cfg.propertyName]: cfg.propertyValue },
          })),
        }),
      });
    }
    return Object.keys(updates).length > 0 || toAdd.length > 0;
  }

  // Make the cart match the promo: gifts present (qty 1) when the racket is there, gone when it isn't.
  async function reconcile() {
    if (busy) return false;
    busy = true;
    try {
      const cart = await getCart();
      return await syncGifts(cart, racketQtyIn(cart));
    } catch (e) {
      console.error('[CTPC promo]', e);
      return false;
    } finally {
      busy = false;
    }
  }

  // Redraw the cart drawer / cart page / cart count after we changed things behind the theme's back.
  function refreshCartUI() {
    getCart()
      .then((cart) => {
        const empty = cart.item_count === 0;
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.toggle('is-empty', empty);
        const inner = document.querySelector('cart-drawer .drawer__inner');
        if (inner) inner.classList.toggle('is-empty', empty);
        const footer = document.getElementById('main-cart-footer');
        if (footer) footer.classList.toggle('is-empty', empty);
        const items = document.querySelector('cart-items');
        if (items) items.classList.toggle('is-empty', empty);
      })
      .catch(() => {});
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ctpc-promo' });
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      nativeFetch(root + '?section_id=cart-icon-bubble')
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        })
        .catch(() => {});
    }
  }

  // Intercept cart requests the theme makes.
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    const isChange = /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url);

    // Racket being added: put the gifts in first, so the theme's own
    // response (and the drawer it renders) already shows them.
    const adding = isAdd && active() && init ? addedTriggerQty(init.body) : 0;
    if (adding) {
      busy = true;
      try {
        const cart = await getCart();
        await syncGifts(cart, racketQtyIn(cart) + adding);
      } catch (e) {
        console.error('[CTPC promo]', e);
      } finally {
        busy = false;
      }
      return nativeFetch(input, init);
    }

    const response = await nativeFetch(input, init);

    // Quantity changed or line removed: tidy up gifts afterwards.
    if (isChange) {
      response.clone().text().then(() =>
        setTimeout(async () => {
          if (await reconcile()) refreshCartUI();
        }, 50)
      );
    }
    return response;
  };

  // Catch anything already sitting in the cart when the page loads
  // (e.g. racket removed in another tab, or the promo has ended).
  document.addEventListener('DOMContentLoaded', async () => {
    if (await reconcile()) refreshCartUI();
  });
})();
